import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { ICoreProductCategory } from "../types/core";

const API = process.env.REACT_APP_API;

interface UpdateCoreProductCategoryData {
  id: number;
  name?: string;
  order?: number;
}

/**
 * Hook para atualizar uma categoria de produto (core.ProductCategory)
 * Permite atualizar o nome e/ou a ordem da categoria.
 */
const useUpdateCoreProductCategory = () => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, ...data }: UpdateCoreProductCategoryData) => {
      return fetch(`${API}/api/semeadora/core_product_categories/${id}/`, {
        method: "PATCH",
        body: data,
      }) as Promise<ICoreProductCategory>;
    },
    onSuccess: () => {
      // Invalidar cache da lista de categorias
      queryClient.invalidateQueries({ queryKey: ["core_product_categories"] });
    },
    onError: (error) => {
      console.error("Erro ao atualizar categoria de produto", error);
    },
  });
};

export default useUpdateCoreProductCategory;
